import React, { ReactNode, useMemo } from 'react';
import { Table, TableBody } from '@leadsnavi/ui-kit';

interface FixedHeaderTableProps {
  isFixed?: boolean;
  header: ReactNode;
  children: ReactNode;
  height?: string | number;
  className?: string;
}

export const FixedHeaderTable: React.FC<FixedHeaderTableProps> = ({
  isFixed = true,
  header,
  children,
  height = 500,
  className = '',
}) => {
  const styles = useMemo(() => {
    if (typeof height === 'number') {
      return {
        height: `${height}px`,
      };
    }
    return {};
  }, [height]);
  return (
    <div className={` flex flex-col relative ${className}`} style={styles}>
      {/* 表头部分 - 固定 */}
      <div className="  shrink-0 overflow-hidden">
        <Table className="w-full border-none">
          {header}
          {!isFixed ? <TableBody>{children}</TableBody> : null}
        </Table>
      </div>
      {isFixed ? (
        <React.Fragment>
          {/* 内容部分 - 滚动 */}
          <div className="overflow-y-auto overflow-x-hidden grow">
            <Table className="w-full border-none  table-fixed   overflow-hidden">
              <TableBody>{children}</TableBody>
            </Table>
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
};
